module.exports = __webpack_public_path__ + "img/1483370694.a892f669.jpg";